import { postChangeOffer } from '../api/postChangeOffer';

export const setPostChangeOffer = (params, callback) => {
    return async (dispatch, getState) => {
        try {
            await postChangeOffer(params);
            if (callback) {
                callback();
            }
        } catch (error) {
            if (error?.response?.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}